import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-location-rc.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-location-rc.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ViewApplicationLocationRcConstants } from "./view-application-location-rc.constants";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
import { WktConverterUtils } from "../../../../shared/utils/wkt-converter-utils";
import { CreateApplicationLocationRcConstants } from "../../../../create-application/modules/rc/create-application-location-rc/create-application-location-rc.constants";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { AppControllerService } from "../../../../app-controller.service";
import { DatePipe } from "@angular/common";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { ApiProxyConstants } from "../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../app.config";
import { AppRoutingConstants } from "../../../../app-routing.constants";
import { UrlConstants } from "../../../../shared/constants/url.constants";
import { MapService } from "../../../../map/shared/map.service";
import { take } from "rxjs/operators";
import { AutoUnsubPortal } from "../../../../shared/decorators/autounsub-portal.decorator";
let ViewApplicationLocationRcComponent = class ViewApplicationLocationRcComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    appControllerService;
    datePipe;
    selectedApplicationService;
    changeDetectorRefs;
    mapService;
    routerParamsService;
    active;
    propertiesForm;
    descriptionLabel1 = ViewApplicationLocationRcConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = ViewApplicationLocationRcConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = ViewApplicationLocationRcConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = ViewApplicationLocationRcConstants.DESCRIPTION_LABEL_4;
    erfNoTextPlaceHolder = ViewApplicationLocationRcConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = ViewApplicationLocationRcConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = ViewApplicationLocationRcConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = ViewApplicationLocationRcConstants.FARM_NO_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = ViewApplicationLocationRcConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = ViewApplicationLocationRcConstants.ADDRESS_TEXT_PLACEHOLDER;
    titleDeedNumberLabel = ViewApplicationLocationRcConstants.TITLE_DEED_NUMBER_LABEL;
    zoningLabel = ViewApplicationLocationRcConstants.ZONING_LABEL;
    sectionalTitleSchemeNameLabel = ViewApplicationLocationRcConstants.SECTIONAL_TITLE_SCHEME_NAME_LABEL;
    sectionalTitleSchemeNumberLabel = ViewApplicationLocationRcConstants.SECTIONAL_TITLE_SCHEME_NUMBER_LABEL;
    sectionalTitleSchemeUnitLabel = ViewApplicationLocationRcConstants.SECTIONAL_TITLE_SCHEME_UNIT_LABEL;
    extentLabel = ViewApplicationLocationRcConstants.EXTENT_LABEL;
    purchasePriceLabel = ViewApplicationLocationRcConstants.PURCHASE_PRICE_LABEL;
    dateOfSaleLabel = ViewApplicationLocationRcConstants.DATE_OF_SALE_LABEL;
    electricityAccountNumberLabel = ViewApplicationLocationRcConstants.ELECTRICITY_ACCOUNT_NUMBER_LABEL;
    waterAccountNumberLabel = ViewApplicationLocationRcConstants.WATER_ACCOUNT_NUMBER_LABEL;
    refuseAccountNumberLabel = ViewApplicationLocationRcConstants.REFUSE_ACCOUNT_NUMBER_LABEL;
    removePropertyLabel = ViewApplicationLocationRcConstants.REMOVE_PROPERTY_LABEL;
    managingAgentDisableFilterBy = true;
    managingAgentDisableAdd = false;
    managingAgentDisableEditing = false;
    managingAgentGroups = [];
    managingAgentLabel = "Managing agent";
    saveBtnPlaceholder = SharedConstants.SAVE_LABEL;
    erfNoControl = ViewApplicationLocationRcConstants.ERF_NO_CONTROL;
    subdivisionControl = ViewApplicationLocationRcConstants.SUBDIVISION_CONTROL;
    allotmentControl = ViewApplicationLocationRcConstants.ALLOTMENT_CONTROL;
    farmNoControl = ViewApplicationLocationRcConstants.FARM_NO_CONTROL;
    sgCodeControl = ViewApplicationLocationRcConstants.SG_CODE_CONTROL;
    addressControl = ViewApplicationLocationRcConstants.ADDRESS_CONTROL;
    titleDeedNumberControl = ViewApplicationLocationRcConstants.TITLE_DEED_NUMBER_CONTROL;
    zoningControl = ViewApplicationLocationRcConstants.ZONING_CONTROL;
    sectionalTitleSchemeNameControl = ViewApplicationLocationRcConstants.SECTIONAL_TITLE_SCHEME_NAME_CONTROL;
    sectionalTitleSchemeNumberControl = ViewApplicationLocationRcConstants.SECTIONAL_TITLE_SCHEME_NUMBER_CONTROL;
    sectionalTitleSchemeUnitControl = ViewApplicationLocationRcConstants.SECTIONAL_TITLE_SCHEME_UNIT_CONTROL;
    extentControl = ViewApplicationLocationRcConstants.EXTENT_CONTROL;
    purchasePriceControl = ViewApplicationLocationRcConstants.PURCHASE_PRICE_CONTROL;
    dateOfSaleControl = ViewApplicationLocationRcConstants.DATE_OF_SALE_CONTROL;
    electricityAccountNumberControl = ViewApplicationLocationRcConstants.ELECTRICITY_ACCOUNT_NUMBER_CONTROL;
    waterAccountNumberControl = ViewApplicationLocationRcConstants.WATER_ACCOUNT_NUMBER_CONTROL;
    refuseAccountNumberControl = ViewApplicationLocationRcConstants.REFUSE_ACCOUNT_NUMBER_CONTROL;
    managingAgentControl = ViewApplicationLocationRcConstants.MANAGING_AGENT_CONTROL;
    ownerDisableAdd = true;
    ownerDisableFilterBy = true;
    ownerDisableEditing = true;
    ownerGroups = [];
    ownerListLabel = "Owner";
    ownerShowGroupsDropdown = true;
    zones = [];
    applicationLoaded = false;
    mapComponent;
    isMapLoaded = false;
    yesNoOptions = [];
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    rcApplication;
    getLookupsObservableSubscription;
    getTrueCentroidSubscription;
    constructor(applicationViewService, aflaModuleStrategyService, appControllerService, datePipe, selectedApplicationService, changeDetectorRefs, mapService, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appControllerService = appControllerService;
        this.datePipe = datePipe;
        this.selectedApplicationService = selectedApplicationService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.mapService = mapService;
        this.routerParamsService = routerParamsService;
        this.initForm();
        this.getLookups();
        // tslint:disable-next-line:forin
        for (const yesnoenumKey in SharedConstants.YES_NO_ENUM) {
            this.yesNoOptions.push(SharedConstants.YES_NO_ENUM[yesnoenumKey]);
        }
        this.listenForSelectedApplication();
        this.getMetadata();
    }
    ngOnInit() {
        this.listenForRouteParamChange();
    }
    loadMetadata(stepMeta) {
        this.managingAgentGroups = stepMeta.managingAgentGroup;
    }
    ngAfterViewInit() {
        this.mapService.actionPropertyEnabled = false;
    }
    handleRouteChange() {
    }
    getProperties() {
        return this.propertiesForm.get("properties");
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    initForm() {
        this.propertiesForm = this.aflaModuleStrategyService.form.get("propertiesForm");
    }
    syncMapGeometries() {
        const geometries = [];
        this.getProperties().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Rates certificate management graphics", true);
        }
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.appControllerService.selectedModuleID}`,
        };
        this.getLookupsObservableSubscription = this.applicationViewService.getLookupsObservable(params).subscribe({
            next: (response) => this.onGetLookupsCompleted(response),
            error: (error) => {
                this.appControllerService.handleServerErrorMessage(CreateApplicationLocationRcConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const zones = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name?.toLowerCase() === "zoning") {
                    zones.push(JSON.parse(item.content));
                }
            });
        }
        this.zones = zones;
        this.changeDetectorRefs.detectChanges();
    }
    listenForSelectedApplication() {
        this.selectedApplicationService.$selectedApplication.pipe(take(1)).subscribe({
            next: (application) => {
                if (application && application.id >= 0 && !this.applicationLoaded) {
                    this.rcApplication = application;
                    this.setApplicationData();
                    this.applicationLoaded = true;
                }
            }
        });
    }
    setApplicationData() {
        this.getProperties().clear();
        const baysFormArray = this.getProperties();
        this.rcApplication.properties.forEach((property) => {
            // create form groups for each property
            const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(property.shape, 102100);
            const geom = JsonUtils.fromJSON(geometryArc);
            const propertiesFormGroup = this.createFormGroup(property, geom);
            this.setTrueCentroid(geometryArc, propertiesFormGroup, baysFormArray);
            this.syncMapGeometries();
        });
    }
    createFormGroup(property, geom) {
        const dateString = this.datePipe.transform(property.dateOfSale, ViewApplicationLocationRcConstants.DATE_CONST);
        const propertyFormGroup = new FormGroup({
            id: new FormControl(property.id),
            applicationId: new FormControl(property.applicationId),
            erfNo: new FormControl(property.erfNumber),
            subdivision: new FormControl(property.subdivision),
            allotment: new FormControl(property.allotment),
            farmNo: new FormControl(property.farmNumber),
            sgCode: new FormControl(property.sgCode),
            address: new FormControl(property.address),
            titleDeedNumber: new FormControl(property.titleDeedNumber),
            zoning: new FormControl(property.zoning),
            sectionalTitleSchemeName: new FormControl(property.sectionalTitleSchemeName),
            sectionalTitleSchemeNumber: new FormControl(property.sectionalTitleSchemeNumber),
            sectionalTitleSchemeUnit: new FormControl(property.sectionalTitleSchemeUnit),
            extent: new FormControl(property.extent?.toFixed(2), [Validators.required]),
            purchasePrice: new FormControl(property.purchasePrice?.toFixed(2)),
            dateOfSale: new FormControl(dateString),
            electricityAccountNumber: new FormControl(property.electricityAccountNumber),
            waterAccountNumber: new FormControl(property.waterAccountNumber),
            refuseAccountNumber: new FormControl(property.refuseAccountNumber),
            managingAgent: new FormControl(null),
            centroid: new FormControl(null),
            geometry: new FormControl(geom)
        });
        const mangingAgentControl = propertyFormGroup.get("managingAgent");
        propertyFormGroup.get("managingAgent").setValue(property.managingAgent[0]);
        mangingAgentControl.disable();
        return propertyFormGroup;
    }
    setTrueCentroid(geometryArc, newPropertyFormGroup, propertiesFormArray) {
        const proxyUrl = ApiProxyConstants.URL;
        const gpToolUrl = AppConfig.settings.arcGIS.servicesURL + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
        const url = `${proxyUrl}?${gpToolUrl}`;
        const formData = new FormData();
        formData.append("f", "json");
        formData.append("geometryJSON", JSON.stringify(geometryArc));
        this.getTrueCentroidSubscription = this.applicationViewService.getTrueCentroid(url, formData).subscribe({
            next: (response) => {
                newPropertyFormGroup.get("centroid").setValue(response.results[0].value);
                propertiesFormArray.push(newPropertyFormGroup);
                this.active = propertiesFormArray.length - 1;
                this.disableBayControls(propertiesFormArray.length - 1);
                this.syncMapGeometries();
                this.changeDetectorRefs.markForCheck();
            },
            error: (error) => {
                this.appControllerService.handleServerErrorMessage(ViewApplicationLocationRcConstants.TRUE_CENTROID, error, CRUDOperation.Get);
            }
        });
    }
    disableBayControls(bayIndex) {
        const propertyControl = this.getProperties().controls[bayIndex];
        propertyControl.get("erfNo").disable();
        propertyControl.get("subdivision").disable();
        propertyControl.get("allotment").disable();
        propertyControl.get("farmNo").disable();
        propertyControl.get("sgCode").disable();
        propertyControl.get("address").disable();
        propertyControl.get("titleDeedNumber").disable();
        propertyControl.get("zoning").disable();
        propertyControl.get("sectionalTitleSchemeName").disable();
        propertyControl.get("sectionalTitleSchemeNumber").disable();
        propertyControl.get("sectionalTitleSchemeUnit").disable();
        propertyControl.get("extent").disable();
        propertyControl.get("purchasePrice").disable();
        propertyControl.get("dateOfSale").disable();
        propertyControl.get("electricityAccountNumber").disable();
        propertyControl.get("waterAccountNumber").disable();
        propertyControl.get("refuseAccountNumber").disable();
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: DatePipe },
        { type: SelectedApplicationService },
        { type: ChangeDetectorRef },
        { type: MapService },
        { type: RouterParamsService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
ViewApplicationLocationRcComponent = __decorate([
    Component({
        selector: "app-view-application-location-rc",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsubPortal()
], ViewApplicationLocationRcComponent);
export { ViewApplicationLocationRcComponent };
